import React, { useState, useEffect } from "react";
import ReactFlowFromMermaid from "./ReactFlowFromMermaid";
import heartLoading from "../../../../assests/heartLoading.gif";
import axios from "axios";

const LineageTransformationModal = ({ assetName, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [mermaidDiagrams, setMermaidDiagrams] = useState(null);
  const [mermaidTypes, setMermaidTypes] = useState(null);
  const [selectedMermaid, setSelectedMermaid] = useState(null);
  useEffect(() => {
    if (assetName) {
      fetchLineageTransformation(assetName);
    }
  }, [assetName]);

  useEffect(() => {
    if (mermaidDiagrams?.length) {
      const mermaidTypes = mermaidDiagrams.map((d) => d.name);
      setMermaidTypes(mermaidTypes);
      setSelectedMermaid(mermaidDiagrams[0]);
    }
  }, [mermaidDiagrams]);

  const fetchLineageTransformation = async (assetName) => {
    try {
      setLoading(true);
      const apiEndpoint = `${process.env.REACT_APP_API_URL}/lineage-transformation?asset_name=${assetName}`;
      const response = await axios.get(apiEndpoint);
      if (response?.data) {
        setMermaidDiagrams(response.data.mermaid_diagrams);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectMermaid = (mermaidName) => {
    setLoading(true);
    // Just to re render with selected mermaid properly
    setTimeout(() => {
      const _selectedMermaid = mermaidDiagrams.find(
        (d) => d.name === mermaidName
      );
      setSelectedMermaid(_selectedMermaid);
      setLoading(false);
    }, 500);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg shadow-xl w-[90vw] h-[90vh] overflow-hidden">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">
              Lineage Transformation
            </h2>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full"
            title="Close"
          >
            <svg
              className="h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-[8px] overflow-y-auto h-[calc(90vh-80px)]">
          <div className="flex items-center justify-center h-full">
            {loading ? (
              <div className="flex flex-col items-center space-y-3">
                <img src={heartLoading} alt="Loading..." className="h-30" />
                <span className="text-gray-700 text-[20px]">
                  Loading lineage transformation...
                </span>
              </div>
            ) : selectedMermaid ? (
              <ReactFlowFromMermaid
                mermaidDiagram={selectedMermaid?.mermaid_diagram || ""}
                summaries={selectedMermaid?.summaries || []}
                selectedMeramaidName={selectedMermaid?.name}
                mermaidTypes={mermaidTypes || []}
                handleSelectMermaid={handleSelectMermaid}
              />
            ) : (
              <div className="flex flex-col items-center space-y-3">
                <span className="text-gray-700 text-[20px]">
                  No resources found!
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LineageTransformationModal;
